import adjustments from './adjustments'
import evaluation from './evaluation'

export default { adjustments, evaluation }
